import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download single excel
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadSingleExcelReducer(state = initialState.crashboxxFiles.singleExcel, action){

    switch(action.type)
    {
        case types.DOWNLOAD_SINGLEEXCEL_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_SINGLEEXCEL_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_SINGLEEXCEL_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadSingleExcelReducer.js